// eslint-disable-next-line import/prefer-default-export
function createSubmitHandler(validator, setError, successCallback, failureCallback) {
  // NOTE: making event non-mandatory so that it can be used in other usecases
  return event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // NOTE: accumulating value if failureCallback is defined
    const value = validator(!!failureCallback);
    // NOTE: Idk why !value.errored doesn't work here
    if (value.errored === false) {
      setError(value.error, value.value);
      successCallback(value.value);
    } else {
      setError(value.error, value.value);
      if (failureCallback) {
        failureCallback(value.value, value.error);
      }
    }
  };
}

export { createSubmitHandler };
//# sourceMappingURL=submissionHelper.js.map
